import cn from 'clsx'

import { Copy } from 'shared-components'

import { type TextPage as TextPageType } from '../../../../../apps/benmax/src/types/sanity.types'

import s from './TextPage.module.sass'

function TextPage({ title, copy }: TextPageType) {
    return (
        <section className={s.TextPage}>
            <div className={cn(s.Cont, 'container')}>
                {title && <h1 dangerouslySetInnerHTML={{ __html: title }} />}
                {copy && (
                    <div className={s.Copy}>
                        <Copy copy={copy} />
                    </div>
                )}
            </div>
        </section>
    )
}

export default TextPage
